import { EnvironmentType } from "./environment-types";

export const environment = {
  production: false,
  baseUrl: 'https://dev-api.ttvcrackers.com',
  siteUrl: 'https://dev.ttvcrackers.com',
  environment: EnvironmentType.DEVELOPMENT,
};
